import axios from 'axios';
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React from 'react';
import { injectIntl } from 'react-intl';
import { queryCache, useMutation } from 'react-query';
import Alert from "react-s-alert";
import { ImageUploadCustom } from '../../formik';
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";


const SpeakerPhoto = ({ intl, event, speaker, token }) => {

  const [updatePhoto] = useMutation(({ profile }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker-data/profile`,
    method: 'PATCH',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    data: profile
  }).then(response => response.data), {
    onSuccess: (response) => {
      queryCache.setQueryData(['speaker', speaker.speaker_id], profile => ({
        ...profile,
        ...response
      }))
      Alert.closeAll();
      Alert.success("Photo updated successfully")
    },
    onError: (error) => {
      Alert.closeAll();
      Alert.error("Could not update photo")
    }
  })

  return <div className="upload-speaker-container b-shadow">
    <div className="event-header-w-logo">
      <h1 className="post-header">{event.name}</h1>
      {event.logo && <img src={getEncodedImageUrl(event.logo, 120, 60)} alt={event.name} />}
    </div>

    <div className="event-details margin-0">
      {event.venue ? (
        <span>
          <span>
            <i className="fa fa-map-signs" /> {event.venue}
          </span>
          <span>
            <i className="fa fa-calendar" />{" "}
            {moment(event.start).isSame(
              event.end,
              "day"
            )
              ? moment(event.start).format("DD/MM/YYYY")
              : `${moment(event.start).format(
                "DD/MM/YYYY"
              )} to ${moment(event.end).format(
                "DD/MM/YYYY"
              )}`}
          </span>
          <br /><br />
        </span>
      ) : (
        ""
      )}
    </div>

    <Formik
      initialValues={{
        picture: '',
      }}
      onSubmit={values => {
        updatePhoto({
          profile: values
        })
      }}
    >
      {({ submitForm }) => (
        <Form className="speaker-form-container">
          <div className="s-u-row">
            <Field
              component={ImageUploadCustom}
              signingUrl="/speaker-data/s3"
              token={token}
              id="photo"
              defaultImage={speaker.picture
                ? getEncodedImageUrl(speaker.picture, 100, 100)
                : "/images/profile-ico-img.png"
              }
              name="picture"
              accept="image/*"
              buttonEmpty="label.uploadPhoto"
              buttonUploaded={intl.formatMessage({
                id: "label.photoUploaded",
              })}
              maxSize={process.env.REACT_APP_IMAGE_FILE_SIZE_MAX}
              onChange={(e) => {
                submitForm();
              }}
            />
            <div className="speaker-image-row">
              <div className="m-l-40">
                <h4>{speaker.title} {speaker.firstName} {speaker.lastName}</h4>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  </div>
}

export default injectIntl(SpeakerPhoto);
